import { ConceptId } from 'libs/contentful/props';
import { fetchConceptDetails, type ResolvedConcept } from 'libs/contentful/rest';
import { isDraftPreviewEnabled } from 'utils/draftPreview';

interface TaxonomyFetchResult {
  categories: string[];
}

async function fetchTaxonomy(entryConceptIds: ConceptId[]): Promise<TaxonomyFetchResult> {
  const draftPreview = await isDraftPreviewEnabled();
  const allConceptIds = entryConceptIds.map(concept => concept.id);
  const concepts = await fetchConceptDetails(allConceptIds, draftPreview);
  const categories = Array.from(concepts.values(), item => item.label);
  return { categories };
}

interface BlogCategoriesProps {
  concepts: ConceptId[];
}

const BlogCategories = async ({ concepts }: BlogCategoriesProps) => {
  const fetchedConcepts = await fetchTaxonomy(concepts);
  const categories = fetchedConcepts.categories;

  return (
    <>
      <div className="flex flex-col md:flex-row gap-6 mt-4">
        <p className="font-sans font-semibold md:mt-[6px]">Tags:</p>
        <div className="flex flex-col md:flex-row flex-wrap gap-4">
          {categories.map((category, i) => (
            <p key={i} className="w-fit font-sans font-semibold text-sm px-4 py-2 border rounded-2xl">
              {category}
            </p>
          ))}
        </div>
      </div>
    </>
  );
};

export default BlogCategories;
